import { queryOptions } from "@tanstack/react-query";

import type { GetScenariosDto } from "~/data/scenario/get-scenarios.dto";

import { getScenarios } from "~/data/scenario/scenario.service";

export const scenariosQuery = (variables: GetScenariosDto) =>
  queryOptions({
    queryKey: ["scenarios", variables],
    queryFn: () => getScenarios(variables),
    staleTime: Infinity,
    select: (data) => ({
      rows: data.data,
      next: data.meta.next_page,
      total: data.meta.total_items,
    }),
  });
